module.exports = __webpack_public_path__ + "fonts/Rubik-500-cyrillic21.3ecd4ac.woff2";